import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUser } from '@/redux/slices/userSlice';
import {
  Box,
  Divider,
  Typography,
  Checkbox,
  Radio,
  ThemeProvider,
  createTheme,
} from '@mui/material';
import moment from 'moment';
import client from '../../../../lib/feathers';
import axios from 'axios';
import VoteListCell from './components/VoteListCell';
import Container from '@/components/UI/mobile/Container';
import Tab from '@/components/UI/mobile/Tab';
import Footer from './components/Footer';
import { Message } from '@alifd/next';

const theme = createTheme({
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: '1em',
          height: '1em',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
  },
});

const voteDataFormat = {
  title: { label: '議題', value: (val) => val },
  content: { label: '內容', value: (val) => val },
  buildTime: {
    label: '開始時間',
    value: (val) => moment(Number(val)).format('YYYY-MM-DD'),
  },
  endTime: {
    label: '截止時間',
    value: (val) => moment(Number(val)).format('YYYY-MM-DD'),
  },
  voteType: {
    label: '投票限制',
    value: (val) => (val === '0' ? '一戶一票' : '一人一票'),
  },
  optionCheck: {
    label: '選項複選',
    value: (val) => (val === 'true' ? '是' : '否'),
  },
  files: {
    label: '圖片',
    value: function VoteImages(val) {
      return (
        <Box>
          {val.map((img, index) => (
            <img
              key={index}
              src={img}
              alt="圖片"
              style={{ width: '50%', height: 'auto' }}
            />
          ))}
        </Box>
      );
    },
  },
};

const VoteFrontDeskList = () => {
  const [voteArr, setVoteArr] = useState([]);
  const [showVoteModal, setShowVoteModal] = useState(false);
  const [list, setList] = useState(null);
  const [currentIndex, setCurrentIndex] = useState();
  const [options, setOptions] = useState([]);

  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const funFind = useCallback(async () => {
    const result = await axios.get('/ezcon/api/userVoteInformation', {
      params: {
        userId: user.auth.user._id,
      },
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
    });
    return result && result.data ? result.data : [];
  }, [user.auth.user._id]);

  function orderSort(a, b) {
    return parseInt(a.buildTime, 10) > parseInt(b.buildTime, 10) ? 1 : -1;
  }
  function topSort(a, b) {
    return a.top < b.top ? 1 : -1;
  }

  const serverDataUpdate = useCallback(() => {
    funFind().then((result) => {
      setVoteArr(result.sort(topSort, orderSort));
    });
  }, [funFind]);

  useEffect(() => {
    if (!user?.auth?.user?._id) {
      dispatch(fetchUser());
    } else {
      serverDataUpdate();
    }
  }, [dispatch, serverDataUpdate, user]);

  const handleOk = async () => {
    if (options.length === 0) {
      Message.notice('請選擇投票選項');
    } else {
      try {
        const voteResult = client.service('voteResult');
        if (list.voteResult) {
          await voteResult.patch(list.voteResult._id, {
            options,
          });
          Message.success('修改成功');
        } else {
          await voteResult.create({
            voteId: list._id,
            options,
          });
          Message.success('投票成功');
        }
        serverDataUpdate();
        setOptions([]);
        setShowVoteModal(false);
      } catch (err) {
        console.error(err);
        Message.error('投票失敗');
      }
    }
  };

  const handleCancel = () => {
    setShowVoteModal(false);
    setOptions([]);
  };

  return (
    <>
      <Container
        sx={{
          fontSize: '3.6vw',
          display: 'flex',
          flexDirection: 'column',
          '@media (orientation: landscape)': {
            fontSize: '1.8vw',
          },
        }}
      >
        {showVoteModal && (
          <Box
            sx={{
              overflowY: 'auto',
              height: '100%',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingBottom: '6.6vw',
              }}
            >
              {Object.entries(voteDataFormat).map(([key, formatter], index) => (
                <Fragment key={index}>
                  {key !== 'files' && (
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 'inherit',
                          color: '#4b4b4b',
                          opacity: 0.7,
                        }}
                      >
                        {formatter.label}：
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '1.2em',
                        }}
                      >
                        {formatter.value(list[key])}
                      </Typography>
                    </Box>
                  )}
                  {key === 'files' && list.files[0] && (
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 'inherit',
                          color: '#4b4b4b',
                          opacity: 0.7,
                        }}
                      >
                        {formatter.label}：
                      </Typography>
                      {formatter.value(list.files)}
                    </Box>
                  )}
                </Fragment>
              ))}
              <Box>
                <Typography
                  sx={{
                    fontSize: 'inherit',
                    color: '#4b4b4b',
                    opacity: 0.7,
                  }}
                >
                  投票選項：
                </Typography>
                {list.options.map((option, index) => (
                  <ThemeProvider theme={theme} key={index}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',

                        alignItems: 'center',
                      }}
                    >
                      {list.optionCheck === 'true' ? (
                        <Checkbox
                          style={{ marginRight: '1.2em' }}
                          onChange={(_, checked) => {
                            if (checked) {
                              setOptions((prev) => [
                                ...prev,
                                { id: option.id },
                              ]);
                            } else {
                              setOptions((prev) =>
                                prev.filter((item) => item.id !== option.id)
                              );
                            }
                          }}
                          checked={options.some(
                            (item) => item.id === option.id
                          )}
                          disabled={
                            moment().isAfter(Number(list.endTime)) ||
                            (list.reSubmittable === 'false' &&
                              !!list.voteResult)
                          }
                          disableRipple
                        />
                      ) : (
                        <Radio
                          style={{ marginRight: '1.2em' }}
                          onChange={(_, checked) => {
                            if (checked) {
                              setOptions([{ id: option.id }]);
                            }
                          }}
                          checked={options.some(
                            (item) => item.id === option.id
                          )}
                          disabled={
                            moment().isAfter(Number(list.endTime)) ||
                            (list.reSubmittable === 'false' &&
                              !!list.voteResult)
                          }
                          disableRipple
                        />
                      )}
                      <Typography
                        sx={{
                          fontSize: '1.2em',
                          marginRight: '1.2em',
                        }}
                      >
                        {option.title}
                      </Typography>
                    </Box>
                  </ThemeProvider>
                ))}
              </Box>
            </Box>
            <Box>
              <Footer
                onOk={handleOk}
                onCancel={handleCancel}
                showOk={
                  moment().isBefore(moment(Number(list?.endTime))) &&
                  (!list?.voteResult || list?.reSubmittable !== 'false')
                }
              />
            </Box>
          </Box>
        )}
        {!showVoteModal && (
          <>
            <Tab
              options={['一戶一票', '一人一票', '歷史紀錄']}
              value={currentIndex}
              onChange={(val) => {
                setCurrentIndex(val);
              }}
            />
            <Box
              sx={{
                height: '100%',
                overflowY: 'auto',
              }}
            >
              {voteArr
                .filter((vote) => {
                  if (currentIndex === 2) {
                    return (
                      vote.status === false &&
                      vote.buildTime <= moment().valueOf()
                    );
                  } else {
                    return (
                      vote.status === true &&
                      vote.voteType === currentIndex.toString()
                    );
                  }
                })
                .map((list, index, arr) => {
                  return (
                    <React.Fragment key={index}>
                      <VoteListCell
                        {...{
                          title: list.title,
                          status: list.voteResult ? '已投票' : '未投票',
                          voteType:
                            list.voteType === '0' ? '一戶一票' : '一人一票',
                          buildTime: moment(Number(list.buildTime)).format(
                            'YYYY-MM-DD'
                          ),
                          expireTime: moment(Number(list.endTime)).format(
                            'YYYY-MM-DD'
                          ),
                          currentIndex: currentIndex,
                          onClick: () => {
                            setList(list);
                            setShowVoteModal(true);
                            if (list.voteResult) {
                              setOptions(list.voteResult.options);
                            }
                          },
                        }}
                      />
                      {index !== arr.length - 1 && <Divider />}
                    </React.Fragment>
                  );
                })}
            </Box>
          </>
        )}
      </Container>
    </>
  );
};

export default VoteFrontDeskList;
